import style from 'containers/MyHealth/components/MyHealthResultsContext/styles'
const themeStyles = colors => {
  const styles = {
    ...style,
    container: {
      position: 'relative',
      padding: 0
    },
    noDataContainer: {
      padding: 30,
      color: colors.secondaryGray,
      backgroundColor: colors.lighterSmoke
    },
    filterContainer: {
      position: 'relative'
    },
    filterLabel: {
      color: colors.black
    },
    datePicker: {
      borderColor: colors.lighterSmoke
    },
    datePickerSuffixIcon: {
      color: colors.primary
    },
    submitButton: (isMobile) => {
      return {
        display: 'flex',
        alignItems: 'center',
        background: colors.primary,
        color: colors.white,
        textTransform: 'uppercase',
        width: 'fit-content',
        borderRadius: 35,
        justifyContent: 'center',
        minWidth: isMobile ? 'auto' : 120,
        maxHeight: 35
      }
    },
    resetButtonBig: {
      minWidth: 120,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'none',
      border: '1px solid ' + colors.primary,
      color: colors.primary,
      textTransform: 'uppercase',
      width: 'fit-content',
      borderRadius: 35,
      maxHeight: 35
    },
    resetButton: {
      textDecoration: 'underline',
      background: 'none',
      color: colors.red
    },
    smallDiveder: {
      margin: 0,
      borderTop: `1px solid ${colors.silverGray}`
    },
    buttonIcon: {
      fill: colors.white,
      width: 14,
      height: 14
    },
    loadMoreButtonWrapper: {
      display: 'flex',
      justifyContent: 'center'
    }
  }
  return styles
}

export default themeStyles

